import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router";
import { TabBar } from "../components/TabBar";
import { useExerciseLibrary } from "../hooks/useExerciseLibrary";
import { api } from "../api/client";
import { env } from "../env";

const MUSCLE_GROUPS = ["all", "chest", "back", "legs", "shoulders", "arms", "core", "full-body"];

export const Library = () => {
  const { data, loading } = useExerciseLibrary();
  const [q, setQ] = useState("");
  const [muscle, setMuscle] = useState("all");
  const [favs, setFavs] = useState<Set<string>>(new Set());

  useEffect(() => {
    api<string[]>("/favorites")
      .then((ids) => setFavs(new Set(ids)))
      .catch(() => {
        /* ignore */
      });
  }, []);

  const toggleFav = async (id: string) => {
    const isFav = favs.has(id);
    const next = new Set(favs);
    isFav ? next.delete(id) : next.add(id);
    setFavs(next);
    try {
      await api(`/favorites/${id}`, { method: isFav ? "DELETE" : "POST" });
    } catch {
      // revert on failure
      setFavs(favs);
    }
  };

  const filtered = useMemo(() => {
    const lower = q.toLowerCase();
    return data
      .filter((e) => muscle === "all" || e.muscleGroup === muscle)
      .filter(
        (e) =>
          !lower ||
          e.name.toLowerCase().includes(lower) ||
          e.equipment.toLowerCase().includes(lower),
      );
  }, [data, q, muscle]);

  return (
    <>
      <div className="page">
        <h1 className="h1">Exercise library</h1>
        <div className="muted" style={{ marginBottom: 12 }}>
          {data.length} exercises
        </div>
        <div className="search">
          <input placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
        <div className="filters">
          {MUSCLE_GROUPS.map((m) => (
            <span
              key={m}
              className={`chip ${muscle === m ? "active" : ""}`}
              onClick={() => setMuscle(m)}
            >
              {m}
            </span>
          ))}
        </div>

        {loading && <div className="muted">Loading library…</div>}

        {filtered.map((ex) => (
          <Link key={ex.id} className="list-card" to={`/library/${ex.id}`}>
            <div className="thumb">
              {ex.imageKey && env.imagesUrl ? (
                <img
                  src={`${env.imagesUrl}/${ex.imageKey}`}
                  alt=""
                  style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 10 }}
                  onError={(e) => ((e.target as HTMLImageElement).style.display = "none")}
                />
              ) : (
                ex.name.charAt(0)
              )}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700 }}>{ex.name}</div>
              <div className="muted">
                {ex.muscleGroup} · {ex.equipment} · {ex.difficulty}
              </div>
            </div>
            <button
              className="btn small ghost"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                void toggleFav(ex.id);
              }}
              aria-label="favorite"
            >
              {favs.has(ex.id) ? "★" : "☆"}
            </button>
          </Link>
        ))}
      </div>
      <TabBar />
    </>
  );
};
